import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LoginService } from '../services/LoginService';
import { PATIENT_API } from '../ApiNames';
import { useDispatch } from 'react-redux';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { PayPalScriptProvider, PayPalButtons, usePayPalScriptReducer,FUNDING } from "@paypal/react-paypal-js";
import FinaceofficerLayout from '../layout/finaceofficerlayout/FinaceofficerLayout';
export const PatientNewCaseDetails = () => {
    const [searchParams] = useSearchParams();
    const uid = window.sessionStorage.getItem('uid');

    const specialityId = searchParams.get('specialityid');
    const sicknessDesc = searchParams.get('sicknessdesc');
    const sicknessId = searchParams.get('sicknessid');
    const [userData, setUserData] = useState<[]>([]);
    const dispatch = useDispatch();
    // const finalAmount = 2;
    const fetchSpeciality = async () => {
        try {
            const payload = { specility: specialityId, q: 1 };
            const apiname = PATIENT_API.sickness_API;
            const response = await LoginService.getData(apiname, payload);
            setSpeciality(response[0]?.SpecilityName);
            setUserData(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [userData1, setUserData1] = useState<[]>([]);

    const fetchSickness = async () => {
        try {
            const payload = { sicknessid: sicknessId, q: 4 };
            const apiname = PATIENT_API.doctorDETAILS_API;
            const response = await LoginService.getData(apiname, payload);
            setSickness(response[0]?.Sicknessdesc);
            setUserData1(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        fetchSickness();
        fetchSpeciality();
    }, [dispatch]);
    //for panel

    const [Speciality, setSpeciality] = useState('');
    const [Sickness, setSickness] = useState('');
    const [sicknessDes, setSicknessDes] = useState('');
    const createOrder = (data: any, actions: any) => {
        console.log("actions",actions)
        return actions.order.create({
            purchase_units: [{
              amount: {
                    currency_code : "USD",value:'2.00'
              }
            }]
        });
    };
    const navigate=useNavigate();
    const onApprove = (data: any, actions: any) => {
        return actions.order.capture().then((details: any) => {
            let apiname = '/ws_an_upsuccess.php';
            // console.log(total,"amount")
            const paymentDetails = { uid: uid,sick_id:sicknessId,cost:2,sickness:sicknessDesc,speciality:specialityId };
             LoginService.getData(apiname, paymentDetails)
                .then(() => {
                    navigate('/patientcases');
                });
        });
    };
    const ButtonWrapper = ({ showSpinner }: { showSpinner: boolean }) => {
        const [{ isPending }] = usePayPalScriptReducer();
        console.log(isPending,"pending")
  
        return (
            <>
                {(showSpinner && isPending) && <div className="spinner" />}
                <PayPalButtons forceReRender={[2,"USD"]}
                    style={{ layout: 'vertical' }}
                    createOrder={createOrder}
                    className='paypal-buttons'
                    onApprove={onApprove}
                    fundingSource={FUNDING.PAYPAL}
                />
            </>
        );
    };


    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="content-header">
                            <div className="container-fluid">
                                <div className="grid mb-2">
                                    <div className="col-6">
                                        <h1>New Case</h1>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="content">
                            <div className="container-fluid">
                                <div className="grid">
                                    <div className="col-12">
                                        <Card>
                                            <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                <label style={{ marginRight: '10px' }}>Case Type:</label>

                                            </div>
                                        </Card>
                                    </div>
                                </div>


                                <Panel header="Urgent Case" style={{ marginTop: '20px' }} toggleable>
                                    <div className="grid" style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                                        {/* Speciality Field */}
                                        <div style={{ flex: 1 }}>
                                            <label htmlFor="speciality" className="block text-900 font-medium" style={{ marginBottom: '5px' }}>
                                                Speciality
                                            </label>
                                            <InputText
                                                id="speciality"
                                                value={Speciality}
                                                onChange={(e) => setSpeciality(e.target.value)}
                                                className="custom-dropdown-placeholder"
                                                style={{ width: '100%' }}
                                                disabled
                                            />
                                        </div>
                                        {/* Sickness Field */}
                                        <div style={{ flex: 1 }}>
                                            <label htmlFor="sickness" className="block text-900 font-medium" style={{ marginBottom: '5px' }}>
                                                Sickness
                                            </label>
                                            <InputText
                                                id="sickness"
                                                value={Sickness}
                                                onChange={(e) => setSickness(e.target.value)}
                                                className="custom-dropdown-placeholder"
                                                style={{ width: '100%' }}
                                                disabled
                                            />
                                        </div>
                                        {/* Sickness Description Field */}
                                        <div style={{ flex: 1 }}>
                                            <label htmlFor="sicknessDesc" className="block text-900 font-medium" style={{ marginBottom: '5px' }}>
                                                Sickness Description
                                            </label>
                                            <InputText
                                                id="sicknessDesc"
                                                placeholder="Enter Sickness Description"
                                                value={sicknessDesc}
                                                onChange={(e) => setSicknessDes(e.target.value)}
                                                style={{ width: '100%' }}
                                                disabled
                                            />
                                        </div>
                                        <div style={{ maxWidth: "50px", minHeight: "20px" }}>
                                            {/* <PayPalScriptProvider options={{ clientId: "ARnY6ALjQgUvySoBshDMM0wurCnqMzLYNfq13FU8mxtetSe5gV1vJgF5rsXD9jlDQk3YaB4zCw8YfeqM", currency: "USD" }}>
                                                <ButtonWrapper showSpinner={false} />
                                            </PayPalScriptProvider> */}
                                           
                                        </div>
                                    </div>
                                </Panel>
                                <div className="grid" style={{marginTop:'30px',marginLeft:'20px'}}>
                                        <div style={{ maxWidth: "50px", minHeight: "20px",alignItems:'start' }}>
                                            <PayPalScriptProvider options={{ clientId: "ARnY6ALjQgUvySoBshDMM0wurCnqMzLYNfq13FU8mxtetSe5gV1vJgF5rsXD9jlDQk3YaB4zCw8YfeqM", currency: "USD" }}>
                                                <ButtonWrapper showSpinner={false} />
                                            </PayPalScriptProvider>
                                        </div>
                                    </div>
                                    <div className="col-3"></div>


                            </div >
                        </section >
                    </div >
                </div>
            </div>
        </div>
    )
}